import React from "react";
import { NavLink, useParams } from "react-router-dom";
import {
  StyledActions,
  StyledListItem,
  StyledListItemContent,
} from "./index.styled";
import { Wallet } from "@lib/types/Billing";
import { StyledFlex } from "@lib/components/MiniComponents/Table/index.styled";
import { Tag, Typography } from "antd";
import WalletTypeIcon from "@lib/components/MiniComponents/Icons/WalletTypeIcon";
import useIntl from "react-intl/lib/src/components/useIntl";
import {
  PaginationType,
  UseMutationProps,
  UseQueryProps,
} from "@lib/types/Api";
import { walletTypeColor } from "@lib/helpers/ColorHelper";
import { AppContext } from "@lib/types";
import { ActionButton } from "@lib/components/MiniComponents/Buttons";
import { getWalletLink } from "../utils";

type Props = {
  item: Wallet;
  deleteQuery: UseMutationProps<Wallet>;
  handleSelectWallet: (wallet: Wallet) => void;
  sidebarCollapsed: boolean;
  context: AppContext;
  customerId?: string;
  leadId?: string;
  walletQuery: UseQueryProps<PaginationType<Wallet>>;
};

const AppsSideBarFolderItem: React.FC<Props> = ({
  item,
  deleteQuery,
  handleSelectWallet,
  sidebarCollapsed,
  context,
  customerId,
  leadId,
  walletQuery,
}) => {
  const { messages } = useIntl();
  const { walletId } = useParams();

  // Context-specific path generation
  const path = getWalletLink({ context, customerId, leadId, item });

  return (
    <StyledListItem
      key={item.id}
      selected={walletId === item.id}
      collapsed={sidebarCollapsed}
    >
      <StyledFlex>
        <NavLink
          to={path}
          style={
            sidebarCollapsed
              ? {
                  flexDirection: "column",
                  padding: 2,
                  paddingLeft: 0,
                }
              : {
                  flexDirection: "row",
                }
          }
        >
          <StyledListItemContent
            className="list-item-content"
            collapsed={sidebarCollapsed}
          >
            <WalletTypeIcon
              type={item.type}
              sidebarCollapsed={sidebarCollapsed}
            />
            <StyledFlex
              style={{ flexDirection: "column", alignItems: "flex-start" }}
            >
              <Typography.Text style={{ fontWeight: 500 }} ellipsis>
                {item.name}
              </Typography.Text>
              {!sidebarCollapsed && (
                <StyledFlex>
                  <Tag
                    style={{ lineHeight: "15px" }}
                    color={walletTypeColor(item.type)}
                  >
                    {messages["walletType"][item.type] as string}
                  </Tag>
                </StyledFlex>
              )}
            </StyledFlex>
          </StyledListItemContent>
        </NavLink>
        <StyledActions className="actions">
          <ActionButton
            type="edit"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              handleSelectWallet(item);
            }}
            noLabel
          />

          <ActionButton
            type="delete"
            onClick={async (e) => {
              e.preventDefault();
              e.stopPropagation();
              await deleteQuery.mutateAsync(item);
              await walletQuery.refetch();
            }}
            itemName="common.wallet"
            disabled={deleteQuery.isPending}
            loading={deleteQuery.isPending}
            noLabel
          />
        </StyledActions>
      </StyledFlex>
    </StyledListItem>
  );
};

export default AppsSideBarFolderItem;
